import { render, staticRenderFns } from "./hcpDialog.vue?vue&type=template&id=64bcaa15&scoped=true"
import script from "./hcpDialog.vue?vue&type=script&lang=js"
export * from "./hcpDialog.vue?vue&type=script&lang=js"
import style0 from "./hcpDialog.vue?vue&type=style&index=0&id=64bcaa15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bcaa15",
  null
  
)

export default component.exports